import { Pipe, PipeTransform } from '@angular/core';
import { PersonnePhysiqueDto } from '../../models/personne-physique-dto.model';

@Pipe({
  name: 'idNatPS'
})
export class IdNatPSPipe implements PipeTransform {

  /**
   * Return IdNatPS from personnePhysique object
   * @param personnePhysique PersonnePhysiqueDto
   * @returns IdNatPS
   */
  transform(personnePhysique: PersonnePhysiqueDto): string {
    return (personnePhysique?.typePersonne && personnePhysique?.idPersonne) ?
      `${personnePhysique.typePersonne}${personnePhysique.idPersonne}` : undefined;
  }
}
